<template>
  <div class="header">
    <h2 class="header__title">
      Vuosikello 
    <button class="change-year button button__circle" @click="prevYear"> <i class="icon icon--caret-left"></i> </button>
      {{ selectedYear }} 
    <button class="change-year button button__circle" @click="nextYear"> <i class="icon icon--caret-right"></i> </button>
      <span class="beta">beta</span>
    </h2>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      selectedYear: 0,
    };
  },
  computed: {
    ...mapState(["year"])
  },
  mounted() {
    this.selectedYear = this.year;
    this.$emit("yearChanged", this.selectedYear);
    this.$store.commit("SET_YEAR", this.selectedYear);
  },
  methods: {
    prevYear() {
      this.selectedYear--;
      this.$emit("yearChanged", this.selectedYear);
      this.$store.commit("SET_YEAR", this.selectedYear);
    },
    nextYear() {
      this.selectedYear++;
      this.$emit("yearChanged", this.selectedYear);
      this.$store.commit("SET_YEAR", this.selectedYear);
    }
  }
};
</script>

.<style lang="scss">
.change-year {
  display: inline-flex;
  i {
    width: 3rem;
    height: 3rem;
  }
}
.header {
  position: relative;
  display: none;
  width: 100%;
  padding: 1em 2em 1em 2.5em;
  margin: 0 0 2.5em;
  color: white;
  @include bp(md) {
    display: block;
  }
  &__title {
    display: flex;
    align-items: center;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: -20em;
    width: calc(100% + 20em);
    height: 100%;
    background: $lightred;
    border-top-left-radius: 2.5em;
    border-bottom-left-radius: 2.5em;
    box-shadow: $shadow_sm;
    z-index: -1;
  }

  .beta {
    font-size: 50%;
  }
}
</style>
